import {
  IProviderProps,
  IProvider,
  IProviderEditProps,
  IProviderCreateProps,
  IGuestProviderCreateProps,
} from "interfaces/Provider";
import {
  activeProvider,
  createGuestProviderService,
  createProvidersService,
  deleteProvider,
  updateProvidersService,
} from "../ProvidersServices";

export function handleProviderActiveSubmit({
  provider,
  setModal,
}: IDeleteProviderRegisterProps) {
  if (provider) {
    activeProvider(provider.id)
      .then((res) => {
        localStorage.setItem("message", "Fornecedor ativado com sucesso");
        window.location.reload();
      })
      .catch((err) => {
        console.log(err.response);
      });
  } else {
    console.log("no provider is selected");
  }
}

export function handleProviderDeleteSubmit({
  provider,
  setModal,
}: IDeleteProviderRegisterProps) {
  if (provider) {
    deleteProvider(provider.id)
      .then((res) => {
        localStorage.setItem("message", "Fornecedor desativado com sucesso");
        window.location.reload();
      })
      .catch((err) => {
        console.log(err.response);
      });
  } else {
    console.log("no provider is selected");
  }
}

interface IDeleteProviderRegisterProps {
  setModal: (value: boolean) => void;
  provider?: IProvider;
}

export async function handleGuestProviderCreateSubmit({
  name,
  cnpj,
  tradingName,
  managerName,
  cpf,
  email,
  password,
  rg,
  role,
  tenantId,
  services
}: IGuestProviderCreateProps) {
  const body: IGuestProviderCreateProps = {
    name,
    tradingName,
    managerName,
    email,
    password,
    rg,
    tenantId,
    services
};

  role === 2 ? (body["cnpj"] = cnpj) : (body["cpf"] = cpf);

  return await createGuestProviderService(body);
}

export async function handleProviderCreateSubmit({
  name,
  cnpj,
  tradingName,
  managerName,
  cpf,
  email,
  password,
  rg,
  role,
  services
}: IProviderCreateProps) {
  const body: IProviderCreateProps = {
    name,
    tradingName,
    managerName,
    email,
    password,
    rg,
    services
};

  role === 2 ? (body["cnpj"] = cnpj) : (body["cpf"] = cpf);

  return await createProvidersService(body);
}

export async function handleProviderUpdateSubmit({
  userId,
  password,
  cpf,
  email,
  name,
  rg,
  role,
  providerId,
  cnpj,
  corporativeEmail,
  managerName,
  tradingName,
  services
}: IProviderEditProps) {
  if (role === 2) {
    return await updateProvidersService({
      userId,
      password,
      email,
      name,
      rg,
      providerId,
      cnpj,
      corporativeEmail,
      managerName,
      tradingName,
      services
})
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err.response;
      });
  } else {
    return await updateProvidersService({
      userId,
      password,
      email,
      name,
      rg,
      providerId,
      cpf,
      corporativeEmail,
      managerName,
      tradingName,
      services
    })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err.response;
      });
  }
}
